import Swal from "sweetalert2";

const useTranslationException = (t, i18n) => {
  const exceptionTitleFallback = "exception.DEFAULT";

  const getExceptionNameFor = (title) => {
    return i18n.exists("exception." + title)
      ? t("exception." + title)
      : t(exceptionTitleFallback);
  };

  const warningTitles = [
    "ORDERS_INVALID_PROVIDER",
    "LOTTERY_STOCK_ITEM_ALREADY_FOUND",
    "AGENCY_STOCK_ITEM_ALREADY_FOUND",
    "GAME_NOT_UNIQUE_BY_GAME",
    "GAME_ALREADY_EXISTS",
    "RAFFLE_PAST_RAFFLE_DATE",
    "PREDISTLOG_FILE_NOT_FOUND",
    "DELIVERY_NOTE_ALREADY_EXISTS",
    "AGENCY_NOT_FOUND",
    "RAFFLE_NOT_FOUND",
    "COUPON_NOT_FOUND",
    "RAFFLE_PRIZES_NOT_FOUND",
    "SUPPLIER_DUPLICATED_BY_CUIT",
    "SUPPLIER_DUPLICATED_BY_NAME",
    "WINNING_COUPONS_FILE_CATEGORY_INVALID",
    "WINNING_COUPONS_FILE_CATEGORY_BAD_FORMAT",
  ];

  const showErrorModalForServiceException = (e, options, preamble, title) => {
    let message = "";
    console.log("e", e);
    if (e?.isServiceException && e?.title) {
      if (warningTitles.includes(e?.title)) {
        const title = getExceptionNameFor(e.title);
        return Swal.fire({
          icon: "warning",
          title: title || t("warning"),
          showConfirmButton: options?.showConfirmButton || true,
          timer: options?.timer || 0,
        });
      }
      message =
        (preamble ? preamble + ": " : "") + getExceptionNameFor(e.title);
    } else {
      message = preamble || t("error");
    }
    return Swal.fire({
      icon: options?.icon || "error",
      title: title || t("error"),
      text: message,
      showConfirmButton: options?.showConfirmButton || true,
      timer: options?.timer || 0,
    });
  };

  return { getExceptionNameFor, showErrorModalForServiceException };
};

export default useTranslationException;
